// Mirror of src/modules/billing/plans.ts (server) — keep the two in sync.
export type PlanKey = 'PRO' | 'PLUS' | 'BUSINESS';

export interface PlanInfo {
  key: PlanKey;
  name: string;
  price: string;
  monthlyLimit: number;
  /** Templates may have several signers. */
  multiSigner: boolean;
  hint: string;
}

/** Smallest plan first — the order of upgrades. */
export const PLANS: PlanInfo[] = [
  { key: 'PRO', name: 'SignShield Pro', price: '9.99', monthlyLimit: 50, multiSigner: false, hint: 'For most stores' },
  { key: 'PLUS', name: 'SignShield Plus', price: '19.99', monthlyLimit: 150, multiSigner: true, hint: 'For growing stores' },
  { key: 'BUSINESS', name: 'SignShield Business', price: '29.99', monthlyLimit: 300, multiSigner: true, hint: 'For busy stores' },
];

export const planInfo = (key: string | null | undefined): PlanInfo =>
  PLANS.find((p) => p.key === key) ?? PLANS[0];

/** The next bigger plan to suggest when a store needs more (none above Business). */
export const nextPlanUp = (key: string | null | undefined): PlanInfo | undefined =>
  PLANS[PLANS.indexOf(planInfo(key)) + 1];

/** The cheapest plan that includes multiple signers. */
export const MULTI_SIGNER_PLAN: PlanInfo = PLANS.find((p) => p.multiSigner)!;
